import { SiteContext } from '../SiteContext';
import useContext from '../hooks/useContext';
import { VersionType, resolveApiVersion } from './versionResolver';

export default (versionType?: VersionType) => {
  const {
    data: { commerceUrl },
  } = useContext(SiteContext);
  const versionedCommerceUrl = resolveApiVersion(commerceUrl, 'commerce', versionType);

  return { commerceUrl: versionedCommerceUrl };
};
